import { render, staticRenderFns } from "./StyleEditor.vue?vue&type=template&id=4935de88&scoped=true"
import script from "./StyleEditor.vue?vue&type=script&lang=ts"
export * from "./StyleEditor.vue?vue&type=script&lang=ts"
import style0 from "./StyleEditor.vue?vue&type=style&index=0&id=4935de88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935de88",
  null
  
)

export default component.exports